import React, { useEffect, useState } from "react";
import $ from 'jquery-validation';

export default function CartExpireCountdown({
    count, //to reset timer from parent
    onPreserveCart = f => f,
}) {
    const [seconds, setSeconds] = useState(0);
    const [minutes, setMinutes] = useState(30);
    const [isPreservingCart, setPreservingCart] = useState(false);

    useEffect(() => {
        const endTime = new Date().getTime() + 30 * 60 * 1000;
        countdown(endTime, onTimerEnd);        
    }, [count]);

    function showTime(remainingTime) {
        const seconds = pad((remainingTime / 1000) % 60);
        const minutes = pad((remainingTime / (60 * 1000)) % 60);

        setMinutes(minutes);
        setSeconds(seconds);
    }

    function countdown(endDate, callback = f => f) {
        const end = new Date(endDate).getTime();
        let interval;
      
        function tick() {
          const current = new Date().getTime();
          const remaining = end - current;
      
          if (remaining <= 0) {
            clearInterval(interval);
            callback();
          } else {
            showTime(remaining);
            interval = requestAnimationFrame(tick);
          }
        }
      
        tick();
    }

    // pad value with zero
    function pad(value) {
        return ('0' + Math.floor(value)).slice(-2);
    }

    function onTimerEnd() {
        $('#expiredModal').modal("show");
    }

    const TimeDisplay = ({ minutes, seconds }) => {
        return (
            <div className="d-flex">
                <div>
                    <h3 className="mb-0 text-center body-font font-weight-bold">
                        { minutes }
                    </h3>
                    <p className="small m-0">minutes</p>
                </div>
                <div>
                    <h5 className="m-0 mt-1">:</h5>
                </div>
                <div>
                    <h3 className="mb-0 text-center body-font font-weight-bold">
                        { seconds }
                    </h3>
                    <p className="small m-0">seconds</p>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="alert alert-warning">
                <h5 className="body-font">Cart expires in</h5>
                <TimeDisplay minutes={minutes} seconds={seconds} />
            </div>

            {/* Modal */}
            <div
                className="modal fade"
                id="expiredModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-dialog-centered p-4"
                    role="document"
                >
                    <div className="modal-content">
                        {(isPreservingCart && (
                            <div className="my-5 px-4 text-center">
                                <div className="preloader-wrapper active crazy">
                                    <div className="spinner-layer spinner-red-only spinner-primary">
                                        <div className="circle-clipper left">
                                            <div className="circle"></div>
                                        </div>
                                        <div className="gap-patch">
                                            <div className="circle"></div>
                                        </div>
                                        <div className="circle-clipper right">
                                            <div className="circle"></div>
                                        </div>
                                    </div>
                                </div>
                                <p className="body-font">
                                    Working on preserving your cart...
                                </p>
                            </div>
                        )) || (
                            <React.Fragment>
                                <div className="modal-header border-none pb-0">
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={() =>
                                            window.location.reload(false)
                                        }
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center pb-5">
                                    {/* <h2 className="modal-title body-font font-weight-bold">
                                        Your cart has expired!
                                    </h2>
                                    <p className="body-font">
                                        We couldn't hold your spot any longer.
                                    </p> */}

                                    <h2 className="modal-title body-font font-weight-bold">
                                        Your cart has expired!
                                    </h2>
                                    <p className="body-font">
                                        We couldn't hold your spot any longer.
                                    </p>

                                    <button
                                        className="mt-3 btn btn-lg btn-rounded white-text btn-primary py-2 px-4"
                                        onClick={() => {
                                            setPreservingCart(true);
                                            onPreserveCart();
                                        }}
                                    >
                                        <i className="fa fa-box-check mr-2"></i>
                                        Preserve cart
                                    </button>
                                    <p className="text-muted my-2">or</p>
                                    <button
                                        className="btn btn-lg btn-rounded white-text btn-secondary py-2 px-4"
                                        data-target="#destination-modal"
                                        data-toggle="modal"
                                        tabIndex="0"
                                    >
                                        Choose Your Destination
                                    </button>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./resources/js/components/CartExpireCountdown/index.js